import { z } from "zod";
import { sha256DigestSchema } from "./identifiers.js";
export const canonicalJsonSchema = z.lazy(() => z.union([
    z.null(),
    z.boolean(),
    z.number().finite(),
    z.string(),
    z.array(canonicalJsonSchema),
    z.record(canonicalJsonSchema),
]));
function compareKeys(left, right) {
    return left < right ? -1 : left > right ? 1 : 0;
}
export function canonicalize(value) {
    if (value === null)
        return "null";
    if (typeof value === "boolean" || typeof value === "string") {
        return JSON.stringify(value);
    }
    if (typeof value === "number") {
        if (!Number.isFinite(value))
            throw new TypeError("canonical JSON rejects non-finite numbers");
        return JSON.stringify(Object.is(value, -0) ? 0 : value);
    }
    if (Array.isArray(value)) {
        return `[${value.map((entry) => canonicalize(entry)).join(",")}]`;
    }
    if (typeof value !== "object") {
        throw new TypeError(`canonical JSON rejects ${typeof value}`);
    }
    const entries = Object.entries(value)
        .filter((entry) => entry[1] !== undefined)
        .sort(([left], [right]) => compareKeys(left, right));
    return `{${entries
        .map(([key, entry]) => `${JSON.stringify(key)}:${canonicalize(entry)}`)
        .join(",")}}`;
}
export function canonicalSha256(value, sha256) {
    return sha256DigestSchema.parse(sha256(canonicalize(value)));
}
export async function createProtocolSignature(payloadDigest, signer) {
    return {
        keyId: signer.keyId,
        algorithm: signer.algorithm,
        value: await signer.sign(sha256DigestSchema.parse(payloadDigest)),
    };
}
export async function verifyProtocolSignature(input) {
    if (input.signature.keyId !== input.trustRoot.keyId ||
        input.signature.algorithm !== input.trustRoot.algorithm) {
        return false;
    }
    return input.trustRoot.verify(sha256DigestSchema.parse(input.payloadDigest), input.signature.value);
}
